import React, { useEffect, useState } from 'react';
import './../assets/css/_paymentDetails.css';
import AgreementCheckboxes from '../components/AgreementCheckboxes';
import { SimulatorModel } from '../models/SimulatorModel';
import { TimePicker } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
interface PaymentDetailsOfProductionProps {
    productionData: any;
    authorizedToDriveData: any;
    gender: any;
    maritalStatus: any;
    agreementAlert: boolean;
    setAgreements: (name: string) => void;
    usersSignatures: any;
    setUserSignature: (value: string) => void;
    setEndTime: (value: string) => void;
    renderValidationError: (name: string) => React.ReactNode,
    onUpdateComprehensivePaymentDetails: (newDetails: string[], paymentNumber: number) => void;
    onUpdateCompulsoryPaymentDetails: (newDetails: string[], paymentNumber: number) => void;
    onUpdateRidersPaymentDetails: (newDetails: string[], paymentNumber: number) => void;
    setStateData: (name: string, e: any) => void,
    setCheckboxContactCalling: (e: any) => void,
    callingContactChecked: boolean,
    onChangeFromErrorToValid: (name: string) => void,
}

const PaymentDetailsOfProduction: React.FC<PaymentDetailsOfProductionProps> = ({
    productionData,
    authorizedToDriveData,
    gender,
    maritalStatus,
    agreementAlert,
    setAgreements,
    usersSignatures,
    setUserSignature,
    setEndTime,
    renderValidationError,
    onUpdateComprehensivePaymentDetails,
    onUpdateCompulsoryPaymentDetails,
    onUpdateRidersPaymentDetails,
    setStateData,
    setCheckboxContactCalling,
    callingContactChecked,
    onChangeFromErrorToValid }) => {


    const [compulsoryNumberOfPayments, setCompulsoryNumberOfPayments] = useState<number>(
        productionData.compulsoryInsuranceNumberOfPayments ? productionData.compulsoryInsuranceNumberOfPayments : 1
    );
    const [timeFormat, setTimeFormat] = useState<string>('HH:mm');
    const parsed = dayjs(productionData.endDate);

    const [comprehensiveNumberOfPayments, setComprehensiveNumberOfPayments] = useState<number>(
        productionData.comprehensiveInsuranceNumberOfPayments ? productionData.comprehensiveInsuranceNumberOfPayments : 1
    );

    const [riderNumOfPayments, setRiderNumOfPayments] = useState<number>(
        productionData.riderNumberOfPayments ? productionData.riderNumberOfPayments : 1
    );



    const [comprehensivePaymentDetails, setComprehensivePaymentDetails] = React.useState(() => {
        if (productionData && productionData.comprehensivePaymentDetails) {
            return productionData.comprehensivePaymentDetails;
        }
        return ["", "", "", "", "", ""];
    });

    const [compulsoryPaymentDetails, setCompulsoryPaymentDetails] = React.useState(() => {
        if (productionData && productionData.compulsoryPaymentDetails) {
            return productionData.compulsoryPaymentDetails;
        }
        return ["", "", "", "", "", ""];
    });

    const [ridersPaymentDetails, setRidersPaymentDetails] = React.useState(() => {
        if (productionData && productionData.ridersPaymentDetails) {
            return productionData.ridersPaymentDetails;
        }
        return ["", "", "", "", "", ""];
    });

    const [address, setAddress] = React.useState<any>("")

    useEffect(() => {
        if (productionData.ownerCustomer != null && productionData.ownerCustomer.customerAddresses != null && productionData.ownerCustomer.customerAddresses.length > 0) {

            setAddress(productionData.ownerAddress.city
                + " " + productionData.ownerAddress.street
                + " " + productionData.ownerAddress.houseNumber
                + " " + productionData.ownerAddress.postalCode);
        }
    }, [])

    useEffect(() => {
        
        setCompulsoryNumberOfPayments(productionData.compulsoryInsuranceNumberOfPayments ? productionData.compulsoryInsuranceNumberOfPayments : 1)
        setComprehensiveNumberOfPayments(productionData.comprehensiveInsuranceNumberOfPayments ? productionData.comprehensiveInsuranceNumberOfPayments : 1)
        setRiderNumOfPayments(productionData.riderNumberOfPayments ? productionData.riderNumberOfPayments : 1)

        setComprehensivePaymentDetails(productionData && productionData.comprehensivePaymentDetails ? productionData.comprehensivePaymentDetails : ["", "", "", "", "", ""])
        setCompulsoryPaymentDetails(productionData && productionData.compulsoryPaymentDetails ? productionData.compulsoryPaymentDetails : ["", "", "", "", "", ""])
        setRidersPaymentDetails(productionData && productionData.ridersPaymentDetails ? productionData.ridersPaymentDetails : ["", "", "", "", "", ""])
    }, [productionData])

    const errorMessages = (fieldName: string) => {
        return renderValidationError(fieldName) ? { border: '1px solid red' } : {}
    }




    const setComprehensiveInsuranceNumberOfPayments = (event: React.ChangeEvent<HTMLSelectElement>) => {

        const newValue = Number(event.target.value);
        setComprehensiveNumberOfPayments(newValue);
        productionData.comprehensiveInsuranceNumberOfPayments = Number(event.target.value);
    };

    const setCompulsoryInsuranceNumberOfPayments = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = Number(event.target.value);
        setCompulsoryNumberOfPayments(newValue);
        productionData.compulsoryInsuranceNumberOfPayments = Number(event.target.value);
    };

    const setriderNumberOfPayments = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = Number(event.target.value);
        setRiderNumOfPayments(newValue);

        productionData.riderNumberOfPayments = Number(event.target.value);
    };



    const setPayerFirstName = (event: React.ChangeEvent<HTMLInputElement>) => {
        productionData.payerFirstName = event.target.value;
    };

    const setPayerPhone = (event: React.ChangeEvent<HTMLInputElement>) => {
        productionData.payerPhone = event.target.value;
    };

    enum PaymentType {
        Compulsory,       // 0
        Comprehensive,     // 1
        Riders,     // 2

    }

    const onCreateTimeChange = (time: any, timeString: any) => {
        console.log(time, timeString);
        setEndTime(timeString);
    };


    const onBlurCreateTime = (e: any) => {
        let newTime = e.target.value;
        // add : after 2 chars
        if (!newTime || newTime == '') {
            return;
        }
        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setEndTime(newTime);
        // setCreateTime(newTime);
        // const data = treatmentsData as TreatmentModel;
        // if (newTime) {
        //     let newDateString = moment(data.eventDate).format('YYYY-MM-DD');
        //     newDateString += "T" + newTime;
        //     data.eventDate = new Date(moment(newDateString).format('YYYY-MM-DDTHH:mm'));
        //     setTreatmentsData(data);
        // }
    }

    const copyDriverDetailsFromOwner = (e: any, filed: string) => {
        const updated = [...comprehensivePaymentDetails]; // new array
        if (e.target.checked) {
            updated[3] = productionData.ownerIdentifier;
            updated[4] = productionData.ownerFirstName + " " + productionData.ownerLastName;
            updated[5] = productionData.ownerContactDetails.number;
        } else {
            updated[3] = "";
            updated[4] = "";
            updated[5] = "";
        }
        setComprehensivePaymentDetails(updated);
        onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
    }




    const copyCompulsoryFromComprehensive = async () => {
        const newValues = [
            getCCNumber(PaymentType.Comprehensive),
            getValidityDate(PaymentType.Comprehensive),
            getCVV(PaymentType.Comprehensive),
            getIdentity(PaymentType.Comprehensive),
            getPayerName(PaymentType.Comprehensive),
            getPayerPhoneNumber(PaymentType.Comprehensive),
        ];

        setCompulsoryPaymentDetails(newValues);
        setCompulsoryNumberOfPayments(comprehensiveNumberOfPayments);
        onUpdateCompulsoryPaymentDetails(newValues, comprehensiveNumberOfPayments);
    }

    const copyRiderFromComprehensive = async () => {
        const newValues = [
            getCCNumber(PaymentType.Comprehensive),
            getValidityDate(PaymentType.Comprehensive),
            getCVV(PaymentType.Comprehensive),
            getIdentity(PaymentType.Comprehensive),
            getPayerName(PaymentType.Comprehensive),
            getPayerPhoneNumber(PaymentType.Comprehensive),
        ];

        setRidersPaymentDetails(newValues);
        setRiderNumOfPayments(comprehensiveNumberOfPayments);
        onUpdateRidersPaymentDetails(newValues, comprehensiveNumberOfPayments);
    }

    const getCCNumber = (paymentType: PaymentType) => {

        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails
                    ? productionData.comprehensivePaymentDetails[0]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails
                    ? productionData.compulsoryPaymentDetails[0]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails
                    ? productionData.ridersPaymentDetails[0]
                    : "";

            default:
                return "";
        }
    };


    const setCCNumber = (paymentType: PaymentType, value: string) => {
        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[0] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[0] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[0] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };


    const getValidityDate = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails
                    ? productionData.comprehensivePaymentDetails[1]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails
                    ? productionData.compulsoryPaymentDetails[1]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails
                    ? productionData.ridersPaymentDetails[1]
                    : "";

            default:
                return "";
        }
    };

    const setValidityDate = async (paymentType: PaymentType, value: string) => {

        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[1] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[1] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[1] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };

    const getCVV = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails
                    ? productionData.comprehensivePaymentDetails[2]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails
                    ? productionData.compulsoryPaymentDetails[2]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails
                    ? productionData.ridersPaymentDetails[2]
                    : "";

            default:
                return "";
        }
    };

    const setCVV = async (paymentType: PaymentType, value: string) => {

        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[2] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[2] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[2] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };

    const getIdentity = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails
                    ? productionData.comprehensivePaymentDetails[3]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails
                    ? productionData.compulsoryPaymentDetails[3]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails
                    ? productionData.ridersPaymentDetails[3]
                    : "";

            default:
                return "";
        }
    };

    const setIdentity = async (paymentType: PaymentType, value: string) => {

        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[3] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[3] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[3] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };

    const getPayerName = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails && productionData.comprehensivePaymentDetails.length == 6
                    ? productionData.comprehensivePaymentDetails[4]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails && productionData.compulsoryPaymentDetails.length == 6
                    ? productionData.compulsoryPaymentDetails[4]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails && productionData.ridersPaymentDetails.length == 6
                    ? productionData.ridersPaymentDetails[4]
                    : "";

            default:
                return "";
        }
    };

    const setPayerName = async (paymentType: PaymentType, value: string) => {

        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[4] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[4] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[4] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };

    const getPayerPhoneNumber = (paymentType: PaymentType) => {
        switch (paymentType) {
            case PaymentType.Comprehensive:
                return productionData && productionData.comprehensivePaymentDetails && productionData.comprehensivePaymentDetails.length == 6
                    ? productionData.comprehensivePaymentDetails[5]
                    : "";

            case PaymentType.Compulsory:
                return productionData && productionData.compulsoryPaymentDetails && productionData.compulsoryPaymentDetails.length == 6
                    ? productionData.compulsoryPaymentDetails[5]
                    : "";

            case PaymentType.Riders:
                return productionData && productionData.ridersPaymentDetails && productionData.ridersPaymentDetails.length == 6
                    ? productionData.ridersPaymentDetails[5]
                    : "";

            default:
                return "";
        }
    };

    const setPayerPhoneNumber = async (paymentType: PaymentType, value: string) => {

        switch (paymentType) {
            case PaymentType.Comprehensive: {
                const updated = [...comprehensivePaymentDetails]; // new array
                updated[5] = value;
                setComprehensivePaymentDetails(updated);
                onUpdateComprehensivePaymentDetails(updated, comprehensiveNumberOfPayments);
                break;
            }
            case PaymentType.Compulsory: {
                const updated = [...compulsoryPaymentDetails];
                updated[5] = value;
                setCompulsoryPaymentDetails(updated);
                onUpdateCompulsoryPaymentDetails(updated, compulsoryNumberOfPayments);
                break;
            }
            case PaymentType.Riders: {
                const updated = [...ridersPaymentDetails];
                updated[5] = value;
                setRidersPaymentDetails(updated);
                onUpdateRidersPaymentDetails(updated, riderNumOfPayments);
                break;
            }
            default:
                break;
        }
    };

    const getPassedTypeOfInsurance = (passedTypeOfInsurance: number, suNumber: number) => {
        if (passedTypeOfInsurance && passedTypeOfInsurance == 2)
            return "ללא";
        if (suNumber)
            return suNumber + "";
        return "";
    }

    const calcRiders = () => {

        var riders = 0;
        if (productionData != null && productionData.rider != null && productionData.rider.riderPackages != null) {

            if (productionData.rider.riderPackages.length > 0) {
                var allRiders = productionData.rider.riderPackages.map((x: any) => x.customerCost).reduce(function (a: any, b: any) { return a != null && b != null ? a + b : 0; });
                if (allRiders != null) {
                    riders = allRiders;

                }
            }

        }
        return riders;
    }


    if (!productionData) {
        return null;
    }

    return (
        <>
            <div className="payment-details">
                {/* <div className="creditcard-details">
                    <div className="summary-item">
                        <span className="label">קסקו:  </span>
                        <span className="value">{" " + productionData.comprehensiveInsurancePrice + " ₪"}</span>
                    </div>
                    <div className="summary-item">
                        <span className="label">חובה:  </span>
                        <span className="value">{" " + productionData.compulsoryInsurancePrice + " ₪"}</span>
                    </div>

                    <div className="summary-item">
                        <span className="label">ריידרים:  </span>
                        <span className="value">{" " + calcRiders() + " ₪"}</span>
                    </div>


                </div> */}

                <div className="covers-details-wapper">
                    <div className='title' style={{ marginTop: '20px' }}>
                        <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>תשלום קסקו</span>
                    </div>
                    {productionData.offer.comprehensivePaymentCard ?
                        <>
                            <div>{productionData.offer.comprehensivePaymentCard}</div>
                        </>

                        : /*productionData.comprehensivePremiumPaymentUrl*/false ?
                            <>
                                <iframe src={productionData.comprehensivePremiumPaymentUrl} style={{ width: '100%', height: '700px' }}></iframe>
                            </>

                            : <>
                                <div className="parameter-row" >
                                    <div className="parameter-item" >
                                        <div className="field" style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                onChange={(e: any) => copyDriverDetailsFromOwner(e, 'comprehensiveNumberOfPayments')}
                                            />

                                            <div className='field-name' style={{ marginLeft: 0 }}>
                                                בעל הרכב הוא בעל כרטיס אשראי
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                מספר כרטיס
                                            </div>
                                            <div className="value">
                                                <input type="text" id='ccNumber' onChange={(e: any) => setCCNumber(PaymentType.Comprehensive, e.target.value)} value={comprehensivePaymentDetails[0]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                מס תשלומים
                                            </div>
                                            <div className="value">
                                                <select id="comprehensiveInsuranceNumberOfPayments" value={comprehensiveNumberOfPayments} onChange={setComprehensiveInsuranceNumberOfPayments} className="select-input">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                תוקף
                                            </div>
                                            <div className="value" style={errorMessages("ccExpireDate")}>
                                                <input type="text" onChange={(e) => {
                                                    let val = e.target.value.replace(/\D/g, ""); // keep only digits
                                                    if (val.length > 2) {
                                                        val = val.slice(0, 2) + "/" + val.slice(2, 4); // insert slash after 2 digits
                                                    }
                                                    setValidityDate(PaymentType.Comprehensive, val);
                                                    onChangeFromErrorToValid("ccExpireDate");
                                                }} value={comprehensivePaymentDetails[1]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                CVV
                                            </div>
                                            <div className="value" style={errorMessages("cvv")}>
                                                <input type="text" onChange={(e: any) => setCVV(PaymentType.Comprehensive, e.target.value)} value={comprehensivePaymentDetails[2]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '150px', minWidth: '150px' }}>

                                        <div className="field">
                                            <div className="field-name">
                                                ת. זהות
                                            </div>
                                            <div className="value" style={errorMessages("ccHolderId")}>
                                                <input type="text" onChange={(e: any) => setIdentity(PaymentType.Comprehensive, e.target.value)} value={comprehensivePaymentDetails[3]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                שם מלא
                                            </div>
                                            <div className="value" style={errorMessages("ccHolder")}>
                                                <input type="text" onChange={(e: any) => setPayerName(PaymentType.Comprehensive, e.target.value)} value={comprehensivePaymentDetails[4]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                טלפון
                                            </div>
                                            <div className="value">
                                                <input type="text" onChange={(e: any) => setPayerPhoneNumber(PaymentType.Comprehensive, e.target.value)} value={comprehensivePaymentDetails[5]} />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>}
                    {productionData.offer.compulsoryPaymentCard ?
                        <>
                            <div className='title' style={{ marginTop: '20px' }}>
                                <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>תשלום חובה</span>
                            </div>
                            <div>{productionData.offer.compulsoryPaymentCard}</div>
                        </>


                        : /*productionData.compulsoryPremiumPaymentUrl*/false ?
                            <>
                                <div className='title' style={{ marginTop: '20px' }}>
                                    <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>תשלום חובה</span>
                                </div>
                                <iframe src={productionData.compulsoryPremiumPaymentUrl} style={{ width: '100%', height: '700px' }}></iframe>
                            </>


                            : <>
                                <div className='title' style={{ marginTop: '20px' }}>
                                    <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>תשלום חובה</span>
                                </div>
                                <div className="parameter-row" >
                                    <div className="parameter-item" >
                                        <div className="field" style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                onChange={(e: any) => copyCompulsoryFromComprehensive()}
                                            />

                                            <div className='field-name' >
                                                העתק פרטי קסקו
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item" >
                                        <div className="field">



                                            <div className="field-name">
                                                מספר כרטיס
                                            </div>
                                            <div className="value" style={errorMessages("ccNumber")}>
                                                <input type="text" onChange={(e: any) => setCCNumber(PaymentType.Compulsory, e.target.value)} value={compulsoryPaymentDetails[0]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                מס תשלומים
                                            </div>
                                            <div className="value" style={errorMessages("ccNumber")}>
                                                <select id="compulsoryInsuranceNumberOfPayments" value={compulsoryNumberOfPayments} onChange={setCompulsoryInsuranceNumberOfPayments} className="select-input">
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                תוקף
                                            </div>
                                            <div className="value" style={errorMessages("compulsoryCcExpireDate")}>
                                                <input type="text"
                                                    onChange={(e) => {
                                                        let val = e.target.value.replace(/\D/g, ""); // keep only digits
                                                        if (val.length > 2) {
                                                            val = val.slice(0, 2) + "/" + val.slice(2, 4); // insert slash after 2 digits
                                                        }
                                                        setValidityDate(PaymentType.Compulsory, val);
                                                    }}
                                                    value={compulsoryPaymentDetails[1]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                CVV
                                            </div>
                                            <div className="value" style={errorMessages("compulsoryCvv")}>
                                                <input type="text" onChange={(e: any) => setCVV(PaymentType.Compulsory, e.target.value)} value={compulsoryPaymentDetails[2]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '150px', minWidth: '150px' }}>

                                        <div className="field">
                                            <div className="field-name">
                                                ת. זהות
                                            </div>
                                            <div className="value" style={errorMessages("compulsoryCcHolderId")}>
                                                <input type="text" onChange={(e: any) => setIdentity(PaymentType.Compulsory, e.target.value)} value={compulsoryPaymentDetails[3]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-row">
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field-name">
                                            <div className="field-name">
                                                שם מלא
                                            </div>
                                            <div className="value" style={errorMessages("compulsoryCcHolder")}>
                                                <input type="text" onChange={(e: any) => setPayerName(PaymentType.Compulsory, e.target.value)} value={compulsoryPaymentDetails[4]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                        <div className="field">
                                            <div className="field-name">
                                                טלפון
                                            </div>
                                            <div className="value">
                                                <input type="text" onChange={(e: any) => setPayerPhoneNumber(PaymentType.Compulsory, e.target.value)} value={compulsoryPaymentDetails[5]} placeholder='שדה חובה*' />
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </>}


                    {productionData.offer && productionData.offer.riders && productionData.offer.riders.length > 0 ?
                        <>
                            <div className='title' style={{ marginTop: '20px' }}>
                                <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>תשלום ריידר</span>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item" >
                                    <div className="field" style={{ display: 'flex', alignItems: 'center' }}>
                                        <input
                                            type="checkbox"
                                            onChange={(e: any) => copyRiderFromComprehensive()}
                                        />

                                        <div className='field-name'>
                                            העתק פרטי קסקו
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                    <div className="field">
                                        <div className="field-name">
                                            מס כרטיס
                                        </div>
                                        <div className="value" style={errorMessages("ccNumber")}>
                                            <input type="text" onChange={(e: any) => setCCNumber(PaymentType.Riders, e.target.value)} value={ridersPaymentDetails[0]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                    <div className="field">
                                        <div className="field-name">
                                            מס תשלומים
                                        </div>
                                        <div className="value" style={errorMessages("ccNumber")}>
                                            <select id="riderNumberOfPayments" value={riderNumOfPayments} onChange={setriderNumberOfPayments} className="select-input">
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="11">11</option>
                                                <option value="12">12</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                    <div className="field">
                                        <div className="field-name">
                                            תוקף
                                        </div>
                                        <div className="value" style={errorMessages("ridersCcExpireDate")}>
                                            <input type="text"

                                                onChange={(e) => {
                                                    let val = e.target.value.replace(/\D/g, ""); // keep only digits
                                                    if (val.length > 2) {
                                                        val = val.slice(0, 2) + "/" + val.slice(2, 4); // insert slash after 2 digits
                                                    }
                                                    setValidityDate(PaymentType.Riders, val);
                                                }}
                                                value={ridersPaymentDetails[1]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '100px', minWidth: '100px' }}>
                                    <div className="field">
                                        <div className="field-name">
                                            CVV
                                        </div>
                                        <div className="value" style={errorMessages("ridersCvv")}>
                                            <input type="text" onChange={(e: any) => setCVV(PaymentType.Riders, e.target.value)} value={ridersPaymentDetails[2]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '150px', minWidth: '150px' }}>

                                    <div className="field">
                                        <div className="field-name">
                                            ת. זהות
                                        </div>
                                        <div className="value" style={errorMessages("ridersCcHolderId")}>
                                            <input type="text" onChange={(e: any) => setIdentity(PaymentType.Riders, e.target.value)} value={ridersPaymentDetails[3]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }}>
                                    <div className="field">
                                        <div className="field-name">
                                            שם מלא
                                        </div>
                                        <div className="value" style={errorMessages("ridersCcHolder")}>
                                            <input type="text" onChange={(e: any) => setPayerName(PaymentType.Riders, e.target.value)} value={ridersPaymentDetails[4]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item" style={{ maxWidth: '180px', minWidth: '180px' }} >
                                    <div className="field">
                                        <div className="field-name">
                                            טלפון
                                        </div>
                                        <div className="value">
                                            <input type="text" onChange={(e: any) => setPayerPhoneNumber(PaymentType.Riders, e.target.value)} value={ridersPaymentDetails[5]} placeholder='שדה חובה*' />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </> : ""}



                    <div className='title' style={{ marginTop: '20px' }}>
                        <span style={{ marginRight: '10px', marginTop: '10px', fontSize: 18 }}>פרטי בעל הרכב</span>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>
                        <div className='car-owner-details'>



                            <div className='info-field'>
                                <div className='field-name'>
                                    שם:
                                </div>
                                <div className="value">
                                    {(productionData.ownerFirstName) + " " + (productionData.ownerLastName)}
                                    {/* {productionData.ownerCustomer.fullName} */}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    תעודת זהות:
                                </div>
                                <div className="value">
                                    {productionData.ownerIdentifier}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    ת. לידה:
                                </div>
                                <div className="value">
                                    {productionData.ownerDateOfBirth && productionData.ownerDateOfBirth != null ? moment(productionData.ownerDateOfBirth).format('DD/MM/YYYY')/*new Date(productionData.ownerCustomer.dateOfBirth).toISOString().split('T')[0]*/ : ""}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    מגדר:
                                </div>
                                <div className="value">
                                    {productionData.ownerGender && gender[productionData.ownerGender] ? gender[productionData.ownerGender].description : ""}
                                </div>
                            </div>

                        </div>
                        <div className='car-owner-details'>



                            <div className='info-field'>
                                <div className='field-name'>
                                    כתובת:
                                </div>
                                <div className="value">
                                    {productionData.ownerAddress.city
                                        + " " + productionData.ownerAddress.street
                                        + " " + productionData.ownerAddress.houseNumber
                                        + " " + productionData.ownerAddress.postalCode}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    טלפון:
                                </div>
                                <div className="value">
                                    {productionData.ownerContactDetails != null &&
                                        productionData.ownerContactDetails.length > 0 ? productionData.ownerContactDetails.number : ""}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    דוא"ל:
                                </div>
                                <div className="value">
                                    {productionData.ownerCustomer != null && productionData.ownerContactDetails != null &&
                                        productionData.ownerContactDetails.length > 0 ? productionData.ownerContactDetails.emailAddress : ""}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='title' style={{ marginTop: '20px' }}>
                        <span style={{ marginRight: '10px', fontSize: 18 }}>פרטי הרכב והנהגים</span>
                    </div>
                    <div className='car-owner-details'>

                        <div style={{ fontWeight: 'bold', textAlign: 'start' }}>רכב</div>



                        <div className='info-field'>
                            <div className='field-name'>
                                דגם:
                            </div>
                            <div className="value">
                                {productionData.vehicle.vehicleSubModel != null && productionData.vehicle.vehicleSubModel.name != null ? productionData.vehicle.vehicleSubModel.name : ""}
                            </div>
                        </div>


                        <div className='info-field'>
                            <div className='field-name'>
                                שנת יצור:
                            </div>
                            <div className="value">
                                {productionData.vehicle.carYear}
                            </div>
                        </div>


                        <div className='info-field'>
                            <div className='field-name'>
                                מספר רישוי:
                            </div>
                            <div className="value">
                                {productionData.vehicle.licenseNumber}
                            </div>
                        </div>


                    </div>

                    <div style={{ fontWeight: 'bold', textAlign: 'start' }}>נהגים</div>

                    <div className='info-field'>
                        <div className='field-name'>
                            רשאים לנהוג:
                        </div>
                        <div className="value">
                            {authorizedToDriveData[productionData.authorizedToDrive].description}
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>

                        {(productionData.authorizedToDrive === 0 || productionData.authorizedToDrive === 1) &&
                            <div className='car-owner-details'>
                                <>
                                    <div style={{ textAlign: 'start' }}>נהג עיקרי</div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            שם:
                                        </div>
                                        <div className="value">
                                            {(productionData.driverMainFirstName != null ? productionData.driverMainFirstName : "") + " " + (productionData.driverMainLastName != null ? productionData.driverMainLastName : "")}
                                        </div>
                                    </div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            תאריך לידה:
                                        </div>
                                        <div className="value">
                                            {productionData.driverMainBirthDate && productionData.driverMainBirthDate != null ? moment(productionData.driverMainBirthDate).format('DD/MM/YYYY') : ""}
                                        </div>
                                    </div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            תאריך הוצאת רישיון:
                                        </div>
                                        <div className="value">
                                            {productionData.driverMainSeniorityDate && productionData.driverMainSeniorityDate != null ? moment(productionData.driverMainSeniorityDate).format('DD/MM/YYYY') : ""}
                                        </div>
                                    </div>

                                    <div className='info-field'>
                                        <div className='field-name'>
                                            מגדר:
                                        </div>
                                        <div className="value">
                                            {gender[productionData.driverMainGender].description}
                                        </div>
                                    </div>

                                    <div className='info-field'>
                                        <div className='field-name'>
                                            מצב משפחתי:
                                        </div>
                                        <div className="value">
                                            {maritalStatus[productionData.driverMainMaritalStatus].description}
                                        </div>
                                    </div>
                                </>
                            </div>
                        }

                        {(productionData.authorizedToDrive === 1 || productionData.authorizedToDrive === 2) &&
                            (<div className='car-owner-details'>
                                <>
                                    <div style={{ textAlign: 'start' }}>נהג צעיר</div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            שם:
                                        </div>
                                        <div className="value">
                                            {productionData.driverYoungFirstName != null ? productionData.driverYoungFirstName : ""} {productionData.driverYoungLastName != null ? productionData.driverYoungLastName : ""}
                                        </div>
                                    </div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            תאריך לידה:
                                        </div>
                                        <div className="value">
                                            {productionData.driverYoungBirthDate && productionData.driverYoungBirthDate != null ? moment(productionData.driverYoungBirthDate).format('DD/MM/YYYY') : ""}
                                        </div>
                                    </div>
                                    <div className='info-field'>
                                        <div className='field-name'>
                                            תאריך הוצאת רישיון:
                                        </div>
                                        <div className="value">
                                            {productionData.driverYoungSeniorityDate && productionData.driverYoungSeniorityDate != null ? moment(productionData.driverYoungSeniorityDate).format('DD/MM/YYYY') : ""}
                                        </div>
                                    </div>

                                    <div className='info-field'>
                                        <div className='field-name'>
                                            מגדר:
                                        </div>
                                        <div className="value">
                                            {gender &&  productionData.driverYoungGender?  gender[productionData.driverYoungGender].description: ""}
                                            
                                        </div>
                                    </div>

                                    <div className='info-field'>
                                        <div className='field-name'>
                                            מצב משפחתי:
                                        </div>
                                        <div className="value">
                                            {maritalStatus && productionData.driverYoungMaritalStatus ? maritalStatus[productionData.driverYoungMaritalStatus].description : "" }
                                        </div>
                                    </div>
                                </>
                            </div>)
                        }
                    </div>




                    <div className='title' style={{ marginTop: '20px' }}>
                        <span style={{ marginRight: '10px', fontSize: 18 }}>פרטי ביטוח כיסויים והנחות</span>
                    </div>

                    <div className='car-owner-details'>
                        <div style={{ fontWeight: 'bold', textAlign: 'start' }}>עבר ביטוחי</div>

                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '90%' }}>


                        <div className='car-owner-details'>
                            <div className='info-field'>
                                <div className='field-name'>
                                    שנה אחרונה
                                </div>
                                <div className="value">
                                    { }
                                    {productionData != null ? getPassedTypeOfInsurance(productionData.passedTypeOfInsurance1, productionData.sueNumber1) : ""}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    לפני שנתיים
                                </div>
                                <div className="value">
                                    {productionData != null ? getPassedTypeOfInsurance(productionData.passedTypeOfInsurance2, productionData.sueNumber2) : ""}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    לפני שלוש שנים
                                </div>
                                <div className="value">
                                    {productionData != null ? getPassedTypeOfInsurance(productionData.passedTypeOfInsurance3, productionData.sueNumber3) : ""}
                                </div>
                            </div>
                        </div>


                        <div className='car-owner-details'>
                            <div className='info-field'>
                                <div className='field-name'>
                                    תביעות גוף
                                </div>
                                <div className="value">
                                    {productionData != null ? productionData.bodyClaimsAmount : ""}
                                </div>
                            </div>
                            <div className='info-field'>
                                <div className='field-name'>
                                    שלילות
                                </div>
                                <div className="value">
                                    {productionData != null ? productionData.revocationsAmount : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >

            {
                // make select of list of user who can sign the production
                usersSignatures.length > 0 && <div className='signature-wapper'>
                    <label htmlFor="signatures" className="label"> חתם</label>

                    <select id="signatures" className="select-user"
                        onChange={(e) => setUserSignature(e.target.value)} // Replace with your logic
                        value={productionData.underwriterUserId}
                        style={errorMessages('underwriterUserId')}
                    >
                        <option value="" disabled selected>
                            בחר משתמש
                        </option>
                        {usersSignatures.map((user: { id: number; fullName: string }) => (
                            <option key={user.id} value={user.id}>
                                {user.fullName}
                            </option>
                        ))}
                    </select>
                </div>

            }
            <div className="parameter-row">
                <div className="parameter-item">
                    <div className="field">
                        <div className="field-name">
                            שעת יעד להפקה
                        </div>
                        {/* <div className='signature-wapper' style={{ marginBottom: '20px', marginTop: '20px' }}> */}
                        {/* <label htmlFor="signatures" className="label"> שעת יעד להפקה</label> */}

                        <TimePicker
                            variant="borderless"
                            onChange={onCreateTimeChange}
                            onBlur={onBlurCreateTime}
                            // defaultValue={dayjs(parsed.format(timeFormat), timeFormat)}
                            value={dayjs(parsed.format(timeFormat), timeFormat)}
                            format={timeFormat}
                            popupClassName='time-picker-time-list'
                            status={errorMessages('endTime') ? 'error' : 'warning'}
                            allowClear={false}
                        />
                        <div style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            paddingTop: '5px',
                            color: 'red'
                        }}>
                            {renderValidationError('endTime')}
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="field-name">
                            השיחה בוצעה עם בעל הרכב
                        </div>
                        <input type="checkbox" checked={callingContactChecked} onChange={(e: any) => setCheckboxContactCalling(e)} />
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="field-name">
                            השיחה בוצעה עם:
                        </div>
                        <div className="value" style={errorMessages("contactPersonName")}>
                            <input type="text" value={productionData.contactPersonName} onChange={(e: any) => setStateData("contactPersonName", e.target.value)}
                                placeholder='שדה חובה*' />
                        </div>
                    </div>
                </div>
                <div className="parameter-item">
                    <div className="field">
                        <div className="field-name">
                            טלפון:
                        </div>
                        <div className="value" style={errorMessages("contactPersonPhone")}>
                            <input type="text" value={productionData.contactPersonPhone} onChange={(e: any) => setStateData("contactPersonPhone", e.target.value)}
                                placeholder='שדה חובה*' />
                        </div>
                    </div>
                </div>
            </div>
            <AgreementCheckboxes agreementAlert={agreementAlert} productionData={productionData} setAgreements={setAgreements} />
        </>
    );
}

export default PaymentDetailsOfProduction